import { render, staticRenderFns } from "./ReasonsBlock.vue?vue&type=template&id=2ffadb7b&scoped=true"
import script from "./ReasonsBlock.vue?vue&type=script&lang=js"
export * from "./ReasonsBlock.vue?vue&type=script&lang=js"
import style0 from "./ReasonsBlock.vue?vue&type=style&index=0&id=2ffadb7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffadb7b",
  null
  
)

export default component.exports